// extracted by mini-css-extract-plugin
export var sliderRange = "_nd-2";
export var sliderRoot = "_nd-0";
export var sliderThumb = "_nd-3";
export var sliderTrack = "_nd-1";